import React, { useState } from 'react'

import css from './GroupMap.module.scss'
import classNames from 'classnames'
import Img from 'components/Media/Img'
import { useTranslation } from 'react-i18next'

interface IProps {
  insideCheckout: boolean
  bgImageUrl: string
}

const GroupMap: React.FC<IProps> = (props) => {
  const { insideCheckout, bgImageUrl } = props

  const [showFull, setShowFull] = useState<boolean>(false)

  const { t } = useTranslation()

  const backgroundImage = `url('${bgImageUrl}')`

  return (
    <div
      className={classNames(css.container, { [css.showFull]: showFull, [css.insideCheckout]: insideCheckout })}
      style={{ backgroundImage }}
    >
      <div className={css.showFullBtn} onClick={() => setShowFull(!showFull)}>
        <span>{showFull ? t('common:zoom_out') : t('common:zoom_in')}</span>
        <Img alt="" src="/icons/groups_zoom_icon.svg" />
      </div>
    </div>
  )
}

export default GroupMap
